module.exports = __webpack_public_path__ + "static/media/3.plotting-graphs.d3debba5.png";